// Telegram Mini App: вспомогательные функции. Вне Telegram всё неактивно.
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import i18n from '../i18n';

const getTg = () => {
  try { return (typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp) || null; } catch (e) { return null; }
};

export const isTelegramWebApp = () => {
  const tg = getTg();
  return Boolean(tg && typeof tg.initData === 'string' && tg.initData.length > 0);
};

export const getInitData = () => (isTelegramWebApp() ? getTg().initData : '');

const SUPPORTED = ['ru', 'kk', 'en', 'zh'];
export const langFromSite = () => {
  const l = String((i18n && i18n.language) || 'ru').slice(0, 2);
  return SUPPORTED.includes(l) ? l : 'ru';
};

export const openBotLink = (url) => {
  const tg = getTg();
  if (tg && isTelegramWebApp() && typeof tg.openTelegramLink === 'function' && /^https:\/\/t\.me\//.test(url)) {
    tg.openTelegramLink(url);
  } else {
    window.open(url, '_blank', 'noopener');
  }
};

export const closeMiniApp = () => {
  const tg = getTg();
  try { if (tg && typeof tg.close === 'function') tg.close(); } catch (e) { /* ignore */ }
};

// Тема Telegram применяется, только если пользователь сам не выбирал тему на сайте
const userChoseTheme = () => {
  try { return localStorage.getItem('theme') !== null; } catch (e) { return false; }
};

const META_COLORS = { light: '#ffffff', dark: '#1e1f22' };
const syncTheme = () => {
  const tg = getTg();
  if (!tg || userChoseTheme()) return;
  const scheme = tg.colorScheme;
  if (scheme !== 'light' && scheme !== 'dark') return;
  document.documentElement.setAttribute('data-theme', scheme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', META_COLORS[scheme]);
};

let inited = false;
export const init = () => {
  if (inited || !isTelegramWebApp()) return;
  inited = true;
  const tg = getTg();
  try { tg.ready(); } catch (e) { /* ignore */ }
  try { tg.expand(); } catch (e) { /* ignore */ }
  syncTheme();
  try { if (typeof tg.onEvent === 'function') tg.onEvent('themeChanged', syncTheme); } catch (e) { /* ignore */ }
};

const ROOT_PATHS = ['/', '/main', '/login'];

// Кнопка «Назад» Telegram: на не-главных маршрутах; монтировать внутри Router
export const useTelegramBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname, key } = location;

  useEffect(() => {
    if (!isTelegramWebApp()) return undefined;
    const bb = getTg().BackButton;
    if (!bb) return undefined;
    if (ROOT_PATHS.includes(pathname)) {
      try { bb.hide(); } catch (e) { /* ignore */ }
      return undefined;
    }
    const onBack = () => {
      if (key && key !== 'default') navigate(-1);
      else closeMiniApp();
    };
    try { bb.show(); bb.onClick(onBack); } catch (e) { /* ignore */ }
    return () => { try { bb.offClick(onBack); } catch (e) { /* ignore */ } };
  }, [pathname, key, navigate]);
};
